import * as React from "react"
import {Skeleton} from "@mui/material";


export default function BannersPercentageDynamicSkeleton({ isLoading }) {

	if (!isLoading)
		return <></>

    return <Skeleton
		variant="rectangular"
		height={600}
	/>
}